import { useEffect, useState } from 'react';
import { Row, Col, Card, Alert, Button, Badge } from 'react-bootstrap';
import { FaChalkboardTeacher, FaUserGraduate, FaDollarSign, FaPlayCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import './Dashboard.css';

export default function TeacherDashboard() {
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    api.get('/teacher/profile').then(setProfile).catch(() => {});
  }, []);

  const status = profile?.status;
  const paid = profile && Number(profile.registration_fee_paid) === 1;

  let banner = null;
  if (profile) {
    if (!paid) {
      banner = (
        <Alert variant="warning" className="d-flex justify-content-between align-items-center">
          <span>Your profile isn't visible yet — please pay the registration fee to submit for admin approval.</span>
          <Button as={Link} to="/teacher/profile" size="sm" variant="primary">Go to profile</Button>
        </Alert>
      );
    } else if (status === 'pending') {
      banner = <Alert variant="info">Registration fee paid. Your profile is awaiting admin approval.</Alert>;
    } else if (status === 'approved') {
      banner = <Alert variant="success">Your profile is live. Students can book demos with you.</Alert>;
    } else if (status === 'rejected') {
      banner = <Alert variant="danger">Your profile was rejected by admin. Please contact support.</Alert>;
    }
  }

  return (
    <>
      <h3 className="mb-4">Teacher Dashboard</h3>
      {banner}

      <Row>
        <Col md={3}>
          <Card className="shadow mb-3">
            <Card.Body className="custom-teacher">
              <FaUserGraduate size={30} className="mb-2 text-white" />
              <Card.Title className="text-white">Total Students</Card.Title>
              <h4 className="text-white">0</h4>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="shadow mb-3">
            <Card.Body className="custom-pending">
              <FaPlayCircle size={30} className="mb-2 text-white" />
              <Card.Title className="text-white">Demo Requests</Card.Title>
              <h4 className="text-white">0</h4>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="shadow mb-3">
            <Card.Body className="custom-student">
              <FaChalkboardTeacher size={30} className="mb-2 text-white" />
              <Card.Title className="text-white">My Classes</Card.Title>
              <h4 className="text-white">0</h4>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="shadow mb-3">
            <Card.Body className="custom-profit">
              <FaDollarSign size={30} className="mb-2 text-white" />
              <Card.Title className="text-white">Earnings</Card.Title>
              <h4 className="text-white">₹0</h4>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card className="shadow mt-4">
        <Card.Body>
          <Card.Title>My profile summary</Card.Title>
          {profile ? (
            <>
              <p className="mb-1"><strong>Name:</strong> {profile.name} · <Badge bg={status === 'approved' ? 'success' : status === 'pending' ? 'warning' : 'danger'}>{status}</Badge></p>
              <p className="mb-1"><strong>Subjects:</strong> {(profile.subjects || []).map((s) => s.name).join(', ') || <em className="text-muted">none</em>}</p>
              <p className="mb-1"><strong>City:</strong> {profile.city || <em className="text-muted">not set</em>}</p>
              <p className="mb-1"><strong>Fee:</strong> ₹{Number(profile.monthly_fee).toFixed(0)}/month · ₹{Number(profile.demo_fee).toFixed(0)}/demo</p>
              <Button as={Link} to="/teacher/profile" size="sm" className="mt-2">Edit profile</Button>
            </>
          ) : <p className="text-muted">Loading...</p>}
        </Card.Body>
      </Card>
    </>
  );
}
